var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15 5.414-5.293 5.293a1 1 0 0 1-1.414-1.414l6.646-6.647a1.5 1.5 0 0 1 2.122 0l6.646 6.647a1 1 0 0 1-1.414 1.414L17 5.414V23a1 1 0 1 1-2 0zM1 19a1 1 0 1 1 2 0v8a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-8a1 1 0 1 1 2 0v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3z"
})));
export default SvgUpload;